import { render, staticRenderFns } from "./StrengtheningPrimaryCare.vue?vue&type=template&id=65d6025e&"
import script from "./StrengtheningPrimaryCare.vue?vue&type=script&lang=js&"
export * from "./StrengtheningPrimaryCare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports